(() => {
  const ar = document.documentElement.lang.startsWith('ar');
  function init(root) {
    if (root.hasAttribute('data-home-restored')) return;
    if (root.dataset.krReady) return;
    root.dataset.krReady = 'true';
    const tabs = [...root.querySelectorAll('[data-kr-tab]')];
    function initPanel(panel) {
      if (panel.dataset.ready) return;
      panel.dataset.ready = 'true';
      const rail = panel.querySelector('.kr__rail');
      const products = [...panel.querySelectorAll('[data-kr-product]')];
      const view = panel.querySelector('[data-kr-view]');
      const base = view && new URL(view.href);
      let note = panel.querySelector('[data-selection-note]');
      if (!note) { note = document.createElement('p'); note.dataset.selectionNote = ''; note.className = 'kr-selection-note'; panel.append(note); }
      const updateNote = () => { const count = products.filter(p => !p.hidden).length; note.hidden = count >= 6; note.textContent = ar ? `نعرض ${count} من المنتجات المطابقة. شوف كل المنتجات للتشكيلة الكاملة.` : `Showing ${count} matching products. View all products for the full range.`; };
      updateNote();
      panel.querySelectorAll('[data-kr-persona]').forEach(button => {
        const key = button.dataset.krPersona;
        button.hidden = key !== 'all' && !products.some(p => p.dataset.persona === key);
        button.addEventListener('click', () => {
          panel.querySelectorAll('[data-kr-persona]').forEach(b => b.setAttribute('aria-pressed',String(b === button)));
          products.forEach(p => p.hidden = key !== 'all' && p.dataset.persona !== key);
          if (view && base) { const url = new URL(base); if (key !== 'all') url.searchParams.set('persona',key); view.href=url.href; const banner = panel.querySelector('.kr__banner'); if (banner) banner.href = url.href; }
          const empty = panel.querySelector('[data-home-empty]'); if(empty) empty.hidden=products.some(p=>!p.hidden);
          rail.scrollLeft=0; updateNote();
        });
      });
      if(root.hasAttribute('data-home-restored')) { const first=panel.querySelector('[data-kr-persona]:not([hidden])'); if(first)first.click(); else { const empty=panel.querySelector('[data-home-empty]'); if(empty)empty.hidden=products.length>0; } }
      panel.querySelectorAll('[data-kr-move]').forEach(button => button.addEventListener('click', () => rail.scrollBy({left:Number(button.dataset.krMove) * (ar ? -1 : 1) * rail.clientWidth * .85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));
    }
    function select(tab, focus) {
      let panel = root.querySelector(`[data-kr-panel="${tab.dataset.krTab}"]`);
      if (!panel) { const template = root.querySelector(`[data-kr-template="${tab.dataset.krTab}"]`); if (!template) return; template.after(template.content.cloneNode(true)); panel = root.querySelector(`[data-kr-panel="${tab.dataset.krTab}"]`); }
      root.querySelectorAll('[data-kr-panel]').forEach(p => p.hidden = p !== panel);
      tabs.forEach(t => {t.setAttribute('aria-selected', String(t===tab));t.tabIndex=t===tab?0:-1;});
      initPanel(panel);
      if(focus)tab.focus({preventScroll:true});
    }
    tabs.forEach((tab,index) => {
      tab.addEventListener('click',()=>select(tab));
      tab.addEventListener('keydown',event=>{let next;if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else if(event.key==='ArrowRight')next=(index+(ar?-1:1)+tabs.length)%tabs.length;else if(event.key==='ArrowLeft')next=(index+(ar?1:-1)+tabs.length)%tabs.length;else return;event.preventDefault();select(tabs[next],true);});
    });
    if(tabs[0])select(tabs[0]);else if (!root.hasAttribute('data-kr-empty') && !root.dataset.selectionMode) root.hidden=true;
  }
  document.querySelectorAll('[data-kr]').forEach(init);
  document.querySelectorAll('[data-kr-directory]').forEach(root=>{
    const search=root.querySelector('[data-kr-search]');if(!search)return;
    const cards=[...root.querySelectorAll('[data-kr-name]')];const empty=root.querySelector('[data-kr-no-results]');
    const filter=()=>{const query=search.value.toLowerCase().trim();let count=0;cards.forEach(card=>{card.hidden=!card.dataset.krName.includes(query);if(!card.hidden)count++;});empty.hidden=count>0;};
    search.addEventListener('input',filter);root.querySelector('[data-kr-clear]').addEventListener('click',()=>{search.value='';filter();search.focus();});
  });
  document.addEventListener('shopify:section:load',event=>{event.target.querySelectorAll('[data-kr]').forEach(init);});
})();
